var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "empty-widget" }, [
    _c(
      "div",
      { staticClass: "empty-content" },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v(_vm._s(_vm.icon))]),
        _vm._v(" "),
        _c("div", { staticClass: "message" }, [_vm._v(_vm._s(_vm.message))]),
        _vm._v(" "),
        !_vm.hasValidSettings
          ? _c(
              "a-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("edit")
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("settings"),
                ]),
                _vm._v("\n            Ayarları Düzenle\n        "),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }